import React, { useState, useEffect } from 'react';
import { POISelector } from './poi/POISelector';
import { useLocationTracking } from '@hooks/useLocationTracking';
import { logError, logInfo } from '@utils/logger';

export const QuickSurveyModal = ({ isOpen, onClose, onSave }) => {
  const { userLocation, locationStatus } = useLocationTracking();
  const [selectedLocation, setSelectedLocation] = useState(null);

  // Update selected location when user location changes
  useEffect(() => {
    if (isOpen && userLocation) {
      setSelectedLocation({
        lat: userLocation.lat,
        lng: userLocation.lng
      });
      logInfo('Location set for quick survey:', userLocation);
    }
  }, [isOpen, userLocation, locationStatus]);

  // Reset location when modal closes
  useEffect(() => {
    if (!isOpen) {
      setSelectedLocation(null);
    }
  }, [isOpen]);

  const handleSavePOI = async (data) => {
    try {
      if (onSave) {
        await onSave(data);
      }
      onClose();
    } catch (error) {
      logError('Failed to save POI:', error);
    }
  };

  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 z-50">
      <POISelector
        location={selectedLocation}
        onClose={onClose}
        onSave={handleSavePOI}
      />
    </div>
  );
};